import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let tokenGetter: (() => Promise<string | null>) | null = null;

export const setTokenGetter = (getter: () => Promise<string | null>) => {
  tokenGetter = getter;
};

const getAuthHeaders = async () => {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
  }
  return {};
};

export const getOrganization = async () => {
  const headers = await getAuthHeaders();
  const response = await axios.get(`${BACKEND_URL}/api/v1/org`, { headers });
  return response.data;
};

export const getReports = async () => {
  const headers = await getAuthHeaders();
  const response = await axios.get(`${BACKEND_URL}/api/v1/reports`, { headers });
  return response.data;
};

export const getReport = async (id: string) => {
  const headers = await getAuthHeaders();
  const response = await axios.get(`${BACKEND_URL}/api/v1/reports/${id}`, { headers });
  return response.data;
};

export const generateReport = async (data: any) => {
  const headers = await getAuthHeaders();
  const response = await axios.post(
    `${BACKEND_URL}/api/v1/reports/generate`,
    data,
    { headers }
  );
  return response.data;
};

export default {
  getOrganization,
  getReports,
  getReport,
  generateReport
};
